import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import axios from 'axios';

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { KopkarTable, SelectColumnFilter } from '../../components/KopkarTable';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import { baseAPI } from '../../services/baseAPI';

function SimpananPokok() {

  //Roles
  const BENDAHARA = 5;
  const token = useUserStore((state) => state.token);
  const users = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  const [dataTagihan, setDataTagihan] = useState([]);
  const [totalTagihan, setTotalTagihan] = useState();
  const [dataLogSetor, setDataLogSetor] = useState([]);
  const [dateSetting, setDateSetting] = useState({
    date_start: "",
    date_end: "",
  });


  // CONTROLLER & LOAD DATA
  const fetchTagihan = async () => {
    await axios
      .all(
        [
        baseAPI .get(`/v1/iurananggota`, { headers: { Authorization: `Bearer ${token}` } }),
        baseAPI .get(`/v1/logsetor`, { headers: { Authorization: `Bearer ${token}` } }),
        ]
      )
      .then((res) => {
        const dateStart = res[0].data.data.date_start;
        const dateEnd = res[0].data.data.date_end;
        const dataTagihan = res[0].data.data.simpanan_pokok;
        const total = res[0].data.data.total_pokok;
        const dataLog = res[1].data.data;

        setDateSetting({...dateSetting,
          date_start: dateStart,
          date_end: dateEnd,
        });
        setDataTagihan(dataTagihan);
        setTotalTagihan(total);
        setDataLogSetor(dataLog.simpanan_pokok[0]);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
  };

  const submitTagihan = async () => {
    Swal.fire({
      title: 'Submit tagihan simpanan pokok anggota baru ke dalam database?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Submit',
      denyButtonText: `Jangan Submit`,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const body = new FormData();
        body.append('tagihan', JSON.stringify(dataTagihan));
        body.append('type', dataTagihan[0].type);
        body.append('kode_id', 212);
        body.append('total', totalTagihan);

        baseAPI
          .post(`/v1/iurananggota`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "Data tagihan berhasil ter-submit.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil upload ${JSON.stringify(res)}`);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Data tagihan gagal ter-submit.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
            fetchTagihan();
          })
      } else if (result.isDenied) {
        Swal.fire('Silahkan periksa ulang data tagihan.', '', 'info')
      }
    });
  };

  useEffect(() => {
    setIsLoading(true);
    if (users.role === BENDAHARA) {
      fetchTagihan();
    }
  }, [token]);

  
  // View
  const tagihanView = () => {
    const columns = [
      {
        Header: 'No',
        id: 'row',
        width: '2%',
        accessor: 'no',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.index + 1}</div>,
      },
      {
        Header: 'Id Kopkar',
        id: 'idkopkar',
        width: '8%',
        accessor: 'idkopkar',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.idkopkar}</div>
      },
      {
        Header: 'NPP',
        id: 'npp',
        width: '8%',
        accessor: 'npp',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.npp_anggota}</div>
      },
      {
        Header: 'Nama',
        id: 'nama',
        width: '12%',
        accessor: 'nama',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.name_anggota}</div>
      },
      {
        Header: 'Simpanan Pokok',
        id: 'tagihan',
        width: '8%',
        accessor: 'tagihan',
        sortType: 'basic',
        disableFilters: true,       
        Cell: (cellInfo) => <div className='text-center'>Rp.{parseFloat(cellInfo.row.original.simpanan_pokok).toLocaleString('id-ID')}</div>
      },
    ];

    return (
      <>
        {/* Main card */}
        <div className='row row-deck row-cards'>
          <div className="col-md-12">
            <Card styleBody={{ padding: 0, paddingTop: 20 }}>
              <KopkarTable
                title="Tagihan Simpanan Pokok"
                columns={columns}
                data={dataTagihan}
                formOne={null}
                formTwo={null}
                formThree={null}
                rowSize={[50, 100, 150]}
              />
            </Card>
          </div>

        </div>
      </>
    )
  };

  // VIEW
  const headerView = () => (
    <>
      <div className='page-header'>
        <div className='row align-items-center'>
          {/* Title */}
          <div className='col'>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item Navbar_title'>
                <Link to='#' style={{ color: '#333' }}>Tagihan</Link> /{' '}
                <Link to='/tagihan/simpananpokok' style={{ color: '#333' }}>Simpanan Pokok</Link>
              </li>
            </ol>
          </div>

          {/* Submit ke Database */}
          {/* rubah date start setting di admin, menu setting date */}
          {moment().date() >= dateSetting.date_start 
          ?
          <div className='col-auto ml-auto d-print-none'>
            <button
              disabled={dataLogSetor !== undefined ? true : (dataTagihan.length == 0 ? true : false)}
              type="button"
              className="btn btn-gray"
              style={{ marginLeft: 10 }}
              onClick={() => submitTagihan()}
            >
              <div className="d-flex align-items-center">
                <Icon name="Upload" size={16} style={{ marginRight: 5 }} />{' '}
                <span>Submit ke Database</span>
              </div>
            </button>
          </div>
          : <></>}

        </div>
      </div>
    </>
  );

    
  return (
    <div className='container-fluid'>

      {headerView()}

      {/* main content */}
      <div className='card'>
        <div className='card-body'>
          <div className='row'>
            <b className='text-danger'>Status tagihan: {dataLogSetor !== undefined ? dataLogSetor.type + " " + moment(dataLogSetor.created_at).format("DD/MM/YYYY HH:mm") + " " + "Success" : ""}</b>
            <b className='text-danger'>Total Tagihan: {dataLogSetor !== undefined ? "Rp." + parseFloat(dataLogSetor.total).toLocaleString('id-ID') : "Rp." + parseFloat(totalTagihan).toLocaleString('id-ID')}</b>
          </div>
        </div>
      </div>

      {/* rubah date start setting di admin, menu setting date */}
      {moment().date() >= dateSetting.date_start
      ?
        isLoading ? <LoadingView /> : tagihanView() 
      :
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <p className='text-danger'>Tagihan tersedia pada tanggal 25 setiap bulannya.</p>
            </div>
          </div>
        </div>
      }

    </div>

  );

}

export default SimpananPokok;